<template> 
  <div>
    <div class="card card-custom bg-white border-white border-0">
      <div class="card-custom-img hero-image" v-bind:style="{ 'background-image': 'url(' + imagePath +')' }"></div>
      <div class="card-custom-avatar">
        <img class="img-fluid" :src="images" alt="Avatar" />
      </div>
      <router-link :to="`/show/${search_key}`" v-if="isInOnda() == true" class="btn-floating btn-action ml-auto mr-4 mdb-color lighten-4" title="Guarda Ora">
        <ficon size="2x" class="mt-2" icon="play-circle"></ficon>
      </router-link>
      <div class="card-body pt-4">
        <h3 class="card-title text-left"><strong>{{title}}</strong></h3>
        <p class="card-text text-left descrizione" :title="descrizione">{{descrizione}}</p>
      </div>
      <!--<div class="card-footer" v-if="search_key == 'stiletv'" style="background: inherit; border-color: inherit;">
        <router-link :to="`/show/${search_key}`" class="btn btn-outline-primary">Guarda Ora</router-link>
      </div>-->
      <div class="mdb-color lighten-3 text-center pt-3" >
        <ul class="list-unstyled list-inline font-small text-white">
          <li class="list-inline-item pr-2 white-text"><ficon icon="clock" class="pr-1"></ficon> Inizio: {{hourstoDate(start)}}</li>
          <li class="list-inline-item pr-2 white-text"><ficon icon="clock" class="pr-1"></ficon> Fine: {{hourstoDate(end)}} </li>
        </ul>
      </div>
    </div>
    <!-- Copy until here -->

  </div> 
    
</template>

<script>


import utilfunc from '../models/utilfunc.js';

export default {
  name: 'TgCard',
  data: function() {
    return  {
      
    };
  },
  props: ['images','sigla', 'title' , 'start', 'end', 'descrizione', 'search_key'],
  methods: {    
    hourstoDate(date)
        {
            let hours = utilfunc.datetoHoursStr(date);
            return  hours;
        }, 
    isInOnda()
    {
      let start_tg = new Date(this.start);
      let end_tg = new Date(this.end);
      let current = new Date();

      if(current >= start_tg && current <= end_tg){
        return true;
      }

      return false;
    }    
  },
  computed: {  
    imagePath: function() {
          return require("../assets/images/news.jpg");
    },  
  }
}
</script>


<style scoped>
  .green {
      color: #36B449!important;
  }
  .card-custom {
  overflow: hidden;
  min-height: 250px;
  box-shadow: 0 0 15px rgba(10, 10, 10, 0.3);
}

.descrizione {
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-custom-img {
  height: 120px;
  min-height: 120px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-color: inherit;
}


.card-custom-avatar img {
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(10, 10, 10, 0.3);
  position: absolute;
  top: 55px;
  left: 1.25rem;
  width: 90px;
  height: 90px;
}

.hero-image {
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.mdb-color.lighten-3 {
    background: linear-gradient(to right, #009EE2, #041B37)!important;
}

.mdb-color.lighten-4 {
    background-color: #929fba!important;
}

.card .btn-action {
    margin-top: -1.44rem;
    margin-bottom: -1.44rem;
}

.waves-effect, .waves-light {
    display: inline-block;
}


.font-small {
    font-size: .9rem;
}

.list-inline {
    padding-left: 0;
    list-style: none;
}

.btn-floating {
    -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
    width: 47px;
    height: 47px;
    position: relative;
    z-index: 1;
    vertical-align: middle;
    display: inline-block;
    overflow: hidden;
    -webkit-transition: all .2s ease-in-out;
    -o-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    margin: 10px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
}

</style>